import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface RecentlyViewedItem {
  id: number;
  slug?: string;
  name: string;
  reference: string;
  price: number;
  manufacturer_name?: string;
  image: string | null;
  viewedAt: number;
}

interface RecentlyViewedStore {
  items: RecentlyViewedItem[];
  add: (item: Omit<RecentlyViewedItem, 'viewedAt'>) => void;
  clear: () => void;
}

const MAX = 12;

export const useRecentlyViewedStore = create<RecentlyViewedStore>()(
  persist(
    (set) => ({
      items: [],

      add: (item) => {
        set((state) => {
          const filtered = state.items.filter((i) => i.id !== item.id);
          return {
            items: [{ ...item, viewedAt: Date.now() }, ...filtered].slice(0, MAX),
          };
        });
      },

      clear: () => set({ items: [] }),
    }),
    { name: 'autofrance-recently-viewed' }
  )
);
